<template>
  <div
    v-if="showBanner"
    class="demo-banner"
  >
    <div class="demo-banner__content">
      <div>
        <p class="demo-banner__title">
          {{ t('demo.banner.message') }}
        </p>
        <p
          v-if="organizationName"
          class="demo-banner__organization"
        >
          {{ t('demo.banner.organization_name', { name: organizationName }) }}
        </p>
      </div>
      <button
        class="demo-banner__cta"
        type="button"
        @click="goToSignup"
      >
        {{ t('demo.banner.cta') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/authStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useOrganizationsStore } from '@/stores/organizations'

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()
const notificationStore = useNotificationStore()
const organizationsStore = useOrganizationsStore()

const showBanner = ref(false)
const organizationName = ref('')

const loadOrganization = async () => {
  if (!authStore.isAuthenticated || !authStore.user?.organization_id) {
    showBanner.value = false
    organizationName.value = ''
    return
  }

  try {
    const organization = await organizationsStore.getMyOrganization()
    if (organization?.is_demo) {
      showBanner.value = true
      organizationName.value = organization.name || ''
    } else {
      showBanner.value = false
      organizationName.value = ''
    }
  } catch (error) {
    console.error('Demo banner failed to load organization:', error)
    notificationStore.error(t('demo.banner.load_error'))
    showBanner.value = false
    organizationName.value = ''
  }
}

onMounted(loadOrganization)
watch(() => authStore.user?.organization_id, loadOrganization)

const goToSignup = () => {
  router.push('/auth/signup')
}
</script>

<style scoped>
.demo-banner {
  background: linear-gradient(135deg, #f5d142, #f65d2c);
  color: #1f1f1f;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
  font-size: 0.95rem;
}

.demo-banner__content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.demo-banner__title {
  font-weight: 600;
  margin: 0;
}

.demo-banner__organization {
  margin: 0.25rem 0 0;
  font-size: 0.9rem;
  opacity: 0.85;
}

.demo-banner__cta {
  background: #1b1f3b;
  color: #fff;
  border: none;
  padding: 0.5rem 1.25rem;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.demo-banner__cta:hover {
  transform: translateY(-1px);
}
</style>
